<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Change from "../change.vue";
import Vue from "vue";
export default {
  extends: baseList,
  components: {
    Change,
  },
  data() {
    return {
      table: {
        mname: "patroltemplate",
        key: "id",
        url: {
          del: "/admin/system/template",
        },
        output: false,
        order: "createTime",
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/templateManagement/add",
        },
      ],
      menus: [
        {
          label: "巡检列表",
          name: "inspection_list",
          auth: "system/inspection/index",
        },
        {
          label: "模板管理",
          name: "templateManagement_list",
          auth: "system/templateManagement/index",
        },
        { label: "场景管理", name: "scene_list", auth: "system/scene/index" },
      ],
      filters: [
        {
          label: "巡检名称",
          KeyEnter: this.search,
          name: "patrolName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "巡检名称",
          key: "patrolName",
          minWidth: 120,
          align: "left",
        },
        // {
        //   title: '负责人',
        //   key: 'name',
        //   minWidth: 120,
        //   align: 'center',
        // },
        {
          title: "巡检类别",
          key: "patrolDimension",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.patrolDimension == 1
                ? "资产"
                : row.patrolDimension == 2
                ? "场景"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "巡检目标",
          key: "facilityListName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "场景地址",
          key: "sceneSite",
          minWidth: 120,
          align: "left",
        },
        {
          title: "巡检周期",
          key: "patrolInterval",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.timeUnit == 1
                ? row.patrolInterval + "分钟"
                : row.timeUnit == 2
                ? row.patrolInterval + "小时"
                : row.timeUnit == 3
                ? row.patrolInterval + "天"
                : row.timeUnit == 4
                ? row.patrolInterval + "周"
                : row.timeUnit == 5
                ? row.patrolInterval + "月"
                : row.timeUnit == 6
                ? row.patrolInterval + "季度"
                : row.timeUnit == 7
                ? row.patrolInterval + "年"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        // {
        //   title: '巡检开始时间',
        //   minWidth: 180,
        //   align: 'center',
        //   key: 'patrolBeginTime',
        // },
        {
          title: "巡检时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "system/templateManagement/change" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toChange(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginRight: "5px" }}
                >
                  发布
                </Button>
              );
            },
            "edit",
            "delete",
          ],
          auth: {
            edit: "system/templateManagement/edit",
            del: "system/templateManagement/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //发布
    toChange(row) {
      this.$Modal.success({
        closable: true,
        title: "发布",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Change
              style={{ margin: "0", color: "#19be6b" }}
              id={row.id}
            ></Change>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({
        name: "templateManagement_add",
        query: { action: "add" },
      });
    },
    handleEdit(row) {
      let kv = row.id
      $utils.url.push({ name: 'templateManagement_edit', query: { action: 'edit', kv: kv } })
    },
  },
};
</script>
<style scoped></style>
